export const CELL_LABEL = { seat: "Seat", aisle: "Aisle / empty", door: "Door", wc: "Washroom", driver: "Driver", staff: "Staff seat" };

const copy = (plan) => plan.cells.map((row) => row.map((c) => ({ ...c })));

export function planFromLayout(cap, layout) {
  const [left, right] = (layout || (cap > 33 ? "2+2" : "2+1")).split("+").map(Number);
  const per = left + right; const cols = per + 1;
  const cells = [[{ t: "driver" }, ...Array.from({ length: cols - 2 }, () => ({ t: "aisle" })), { t: "door" }]];
  const rem = cap % per; let n = 1;
  for (let r = 0; r < Math.floor(cap / per) - (rem ? 1 : 0); r++) cells.push(Array.from({ length: cols }, (_, c) => (c === left ? { t: "aisle" } : { t: "seat", n: n++ })));
  while (n <= cap) cells.push(Array.from({ length: cols }, () => (n <= cap ? { t: "seat", n: n++ } : { t: "aisle" })));
  return { rows: cells.length, cols, numbering: "ltr", cells };
}

// Builds a standard plan for a seat count using the current number of columns (one aisle column)
const COL_LAYOUT = { 2: "1+1", 3: "1+1", 4: "2+1", 5: "2+2", 6: "3+2" };
export const planFromSeats = (n, cols) => planFromLayout(n, COL_LAYOUT[cols] || "2+2");

// Front-to-back numbering, each row left-to-right ("ltr") or right-to-left ("rtl")
export function renumber(plan, dir) {
  const cells = copy(plan); let n = 1;
  cells.forEach((row) => { const idx = row.map((_, i) => i); (dir === "rtl" ? idx.reverse() : idx).forEach((i) => { if (row[i].t === "seat") row[i].n = n++; }); });
  return { ...plan, cells, numbering: dir };
}

// Manual numbering: keep the typed order, close gaps, new seats go last
function compact(plan) {
  const seats = [];
  plan.cells.forEach((row, r) => row.forEach((c, i) => c.t === "seat" && seats.push({ r, i, n: c.n ?? Infinity })));
  seats.sort((a, b) => a.n - b.n || a.r - b.r || a.i - b.i);
  const cells = copy(plan);
  seats.forEach((s, k) => { cells[s.r][s.i].n = k + 1; });
  return { ...plan, cells };
}

const tidy = (plan) => (plan.numbering === "manual" ? compact(plan) : renumber(plan, plan.numbering));
export const seatCount = (plan) => plan.cells.flat().filter((c) => c.t === "seat").length;

export function setCell(plan, r, i, t) {
  if (plan.cells[r][i].t === t) return plan;
  const cells = copy(plan);
  cells[r][i] = t === "seat" ? { t } : { t };
  return tidy({ ...plan, cells });
}

export function resize(plan, rows, cols) {
  const cells = Array.from({ length: rows }, (_, r) => Array.from({ length: cols }, (_, i) => ({ ...(plan.cells[r]?.[i] || { t: "aisle" }) })));
  return tidy({ ...plan, rows, cols, cells });
}

// Gives a seat a number; the seat that had that number takes the old one
export function setNumber(plan, r, i, n) {
  const cells = copy(plan); const old = cells[r][i].n;
  cells.forEach((row) => row.forEach((c) => { if (c.t === "seat" && c.n === n) c.n = old; }));
  cells[r][i].n = n;
  return { ...plan, cells, numbering: "manual" };
}
